import { TopPerformerGroup } from '@/app/libs/match/types'
import Card from '@/shared/components/card'
import CustomLink from '@/shared/components/customLink'
import MyImage from '@/shared/components/myImage'
import { getImgURL } from '@/shared/utils'

export default function TopPerformers({ topPerformers }: { topPerformers?: TopPerformerGroup[] }) {
  return (
    <div className="mb-4">
      <p className="text-lg font-bold text-TextOffPlayer">Top Performers</p>
      <div>
        {topPerformers?.map(group => {
          return group?.aPlayers?.length ? (
            <div key={group?.sTitle} className="md:first:mt-2.5 first:!mt-1 mt-5">
              <div className="flex items-center justify-between text-xs leading-4 md:text-base mt-0 mb-2.5">
                <h4 className="text-xs leading-4 md:text-base font-normal text-textDselected my-0">
                  {group?.sTitle}
                </h4>
                {group?.sSubTitle ? (
                  <span className="text-[#EAAE54]">{group?.sSubTitle}</span>
                ) : null}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {group.aPlayers.map(player => {
                  return (
                    <Card
                      key={player?.oPlayer?._id}
                      className="col-span-1 border-none flex gap-2 md:gap-4 items-center relative"
                    >
                      {player?.oPlayer?.oSeo?.eStatus === 'a' && player?.oPlayer?.oSeo?.sSlug ? (
                        <CustomLink
                          href={`/${player?.oPlayer?.oSeo?.sSlug}`}
                          className="absolute inset-0 h-full w-full opacity-0 z-10"
                        >
                          {player?.oPlayer?.sShortName}
                        </CustomLink>
                      ) : null}
                      <MyImage
                        src={getImgURL(player?.oPlayer?.oImg?.sUrl)}
                        className="w-10 h-10 md:w-12 md:h-12 rounded-full"
                        height={48}
                        width={48}
                        alt={player?.oPlayer?.oImg?.sText}
                      />
                      <div className="flex flex-col grow">
                        <p className="text-sm font-medium text-TextOffPlayer">
                          {player?.oPlayer?.sShortName || player?.oPlayer?.sFullName}
                        </p>
                        <p className="text-xs text-textDselected">
                          {player?.oPlayer?.sCountryFull || player?.oPlayer?.sCountry}
                        </p>
                      </div>
                      <div className="flex flex-col justify-self-end">
                        <p className="text-base md:text-xl font-bold text-textOffWhite text-end whitespace-nowrap md:mb-1.5">
                          {player?.sStat ? player?.sStat?.replace?.('(', ' (') : ''}
                        </p>
                        <p className="text-xs md:text-sm text-textDselected md:text-textOffWhite text-end whitespace-nowrap">
                          {player?.sSubTitle}
                        </p>
                      </div>
                    </Card>
                  )
                })}
              </div>
            </div>
          ) : null
        })}
      </div>
    </div>
  )
}
